<template>
	<div class="visibility-columns form-check pl-0">
		<label class="form-check-label dropdown-item p-2" style="font-size: 12px; font-weight: 400">
			<input type="checkbox" class="form-check-input" :value="column.visibility" :checked="column.visibility" @change="changeVisibility(column)" />
			<span class="mr-4">{{ column.title }}</span>
		</label>
	</div>
</template>

<script>
	import $ from 'jquery'

	export default {
		name: 'ColumnsVisibility',

		// Props
		props: {
			column: {
				type: Object,
				default() {
					return {}
				}
			}
		},

		emits: ['change-visibility'],


		// Mounted
		mounted() {
			$(document).on('click', '.visibility-columns', (e) => {
				e.stopPropagation()
			})
		},

		// Methods
		methods: {
			changeVisibility(column) {
				this.$emit('change-visibility', column)
			}
		}
	}
</script>
